import React from 'react';
import PropTypes from 'prop-types';

function Status(props) {
  const { status, show } = props;
  if (show && status === 'InProgress') {
    return <span className="dotO">●</span>;
  } else if (show && status === 'Done') {
    return <span className="dotG">●</span>;
  } else {
    return <span>-</span>;
  }
}

Status.propTypes = {
  status: PropTypes.string.isRequired,
  show: PropTypes.bool
};

export default Status;
